import { createFileRoute, redirect } from "@tanstack/react-router";
import { resolveLegacyTopic } from "@/lib/seo/legacyPaths.functions";

export const Route = createFileRoute("/_app/news-categories/$slug")({
  loader: async ({ params }) => {
    const topic = await resolveLegacyTopic({ data: params.slug });
    if (topic) {
      throw redirect({ to: "/topics/$slug", params: { slug: topic }, statusCode: 301 });
    }
    throw redirect({ to: "/topics", statusCode: 301 });
  },
  component: () => null,
});
